import { BlockSaveProps } from "@wordpress/blocks";
import React from "react";
import type { BlockAttributes } from "./block.json";
import { InnerBlocks } from "@wordpress/block-editor";
import parse from "html-react-parser";

export default function ProfileSave() {
  return null; // Dynamic block rendered on server side
}
